<template>
    <div>
        <div v-show="loadingInspectionData">
            <span class="fa fa-spinner fa-spin"></span>
        </div>
        <div v-show="!loadingInspectionData">
            <div v-if="inspection" class="vue-form text-center">
                <h3>Manage Inspection</h3>
                <form-select
                    field-name="inspector"
                    v-model="newInspectorId"
                    label="Select an inspector to assign"
                    :show-label="false"
                    :options="inspectors"
                    option-label-field="username"
                    option-value-field="id"
                    :show-multiselect-labels="false"
                    :disabled="disabled ? 1 : 0"
                ></form-select>
                <div>
                    <button class="button m-2" @click="assignInspector">Reassign Inspection</button>
                    <button class="button m-2" @click="rewindInspection" v-can="'rewind_inspections'">Rewind Inspection</button>
                </div>
            </div>
            <div v-else class="vue-form">
                <h3>Assign and open inspection</h3>
                <form-select
                    field-name="inspector"
                    v-model="newInspectorId"
                    label="Select an inspector to assign"
                    :show-label="false"
                    :options="inspectors"
                    option-label-field="username"
                    option-value-field="id"
                    :show-multiselect-labels="false"
                    :disabled="disabled ? 1 : 0"
                ></form-select>
                <button class="inputbutton1" @click="assignAndOpenInspection" :disabled="disabled">Assign & Open</button>
            </div>
        </div>
    </div>
</template>
<script>

    export default {

        props: {
            inspectionPhase: {
                required: true,
                type: Object
            },
            projectId: {
                required: true,
                type: Number,
            },
            currentInspectorId: {
                type: Number
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                newInspectorId: null,
                loadingInspectionData: false
            }
        },

        computed: {
            inspection() {
                return this.$store.getters['inspections/getInspectionForProjectAndPhase'](this.projectId, this.inspectionPhase.id);
            },
            inspectors() {
                return this.$store.state.inspections.inspectors;
            }
        },

        watch: {
            'inspection': function(inspection) {

            }
        },

        created() {

            this.loadingInspectionData = true;
            this.loadInspectionData().then(finished => {
                this.loadingInspectionData = false;
                this.newInspectorId = this.currentInspectorId;
            }).catch(error => {
                this.loadingInspectionData = false;
            });

        },


        methods: {
            async loadInspectionData() {

                await this.$store.dispatch('inspections/getInspectors');
                await this.$store.dispatch('inspections/getProjectInspection', {
                    project_id: this.projectId,
                    phase_id: this.inspectionPhase.id
                });

                return true;
            },
            assignAndOpenInspection() {

                if(!this.newInspectorId) {
                    window.notify.message('Please select an inspector', 'error');
                    return;
                }

                this.$store.dispatch('inspections/assignAndOpenInspection', {
                    projectId: this.projectId,
                    phaseId: this.inspectionPhase.id,
                    inspectorId: this.newInspectorId
                }).then(response => {
                    window.notify.message('Successfully assigned and created inspection', 'success');
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000)
                });
            },
            assignInspector() {
                this.$store.dispatch('inspections/reAssignInspector', {
                    projectId: this.projectId,
                    inspectionId: this.inspection.id,
                    inspectorId: this.newInspectorId
                }).then(response => {

                    window.notify.message('Successfully re-assigned inspection', 'success');
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                });
            },
            rewindInspection() {
                this.$store.dispatch('inspections/rewindInspection', {
                    projectId: this.projectId,
                    inspectionId: this.inspection.id
                }).then(response => {

                    window.notify.message('Successfully rewound inspection', 'success');
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000)
                });
            }
        }

    }
</script>
